import { create } from 'app/utils/data'

export const QUOTE_ADD_ONS = [
  { label: 'Pageviews', unit: 'Pageviews', iconName: 'faEye', quantityKey: 'pageviewsAddOn', priceKey: 'pageviewsAddOnPrice' },
  { label: 'Bandwidth (GB)', unit: 'GB Bandwidth', iconName: 'faServer', quantityKey: 'bandwidthAddOn', priceKey: 'bandwidthAddOnPrice' },
  { label: 'Kits', unit: 'Kits', iconName: 'faCube', quantityKey: 'kitsAddOn', priceKey: 'kitsAddOnPrice' },
  { label: 'Custom Icons', unit: 'Custom Icons', iconName: 'faIcons', quantityKey: 'customIconsAddOn', priceKey: 'customIconsAddOnPrice' }
]

export const QUOTE_DEFAULTS = {
  name: '',
  address1: '',
  address2: '',
  phone: '',
  plan: 'Starter',
  numOfSeats: 0,
  price: 0,
  taxRate: 0,
  taxID: '',
  vat: '',
  quoteExpirationDate: '',
  subscriptionPeriod: '',
  ...Object.fromEntries(
    QUOTE_ADD_ONS.flatMap(({ quantityKey, priceKey }) => [
      [quantityKey, ''],
      [priceKey, '']
    ])
  )
}

export default {
  namespaced: true,

  state: {
    quote: { ...QUOTE_DEFAULTS }
  },

  getters: {
    currentQuote: (state) => state.quote
  },

  mutations: {
    quoteSaved(state, newQuote) {
      state.quote = {
        ...state.quote,
        ...newQuote
      }
    }
  },

  actions: {
    saveQuote({ commit }, quote) {
      commit('quoteSaved', quote)
    },

    async sendQuote({ dispatch }, changes) {
      await create({
        url: '/api/admin/tools/send-quote',
        data: changes
      })
    }
  }
}
